<template>
  <div class="group">
    <label :for="name" :class="seeLabel ? '' : 'hide'">{{ label }}</label>
    <input
      class="form-control"
      :type="type"
      :id="name"
      :name="name"
      @focus="hideLabel()"
      @blur="showLabel($event); updateValue($event.target.value);">
      <div v-show="isValidated && errorMessage" class="error">
        <i class="icon icon-x"></i>
        <p>{{ errorMessage }}</p>
      </div>
      <div v-show="isValidated && !errorMessage" class="success"><i class="icon icon-check"></i></div>
  </div>
</template>
<script>
export default {
  name: 'Input',
  props: {
    required: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: String,
    isValidated: {
      type: Boolean,
      default: false,
    },
    errorMessage: String,
  },
  data() {
    return {
      seeLabel: true,
      value: '',
    };
  },
  methods: {
    updateValue (value) {
      this.value = value;
      this.$emit('setValue', this.value);
    },
    hideLabel() {
      this.seeLabel = false;
    },
    showLabel(e) {
      if (e.currentTarget.value === '') {
        this.seeLabel = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .group {
    position: relative;
    width: calc(100% - 20px);
    margin: 0 10px 20px;
    @include respond(md-up) {
      width: calc(50% - 20px);
    }
    
    label {
      position: absolute;
      left: 15px;
      top: 0;
      color: $InputColor;
      line-height: 50px;
      opacity: .5;
      @include transition(all .3s ease);

      @include respond(md-up) {
        line-height: 70px;
      }

      &.hide {
        position: absolute;
        top: -16px;
        font-size: 13px;
        pointer-events: none;

        @include respond(md-up) {
          top: -23px;
        }
      }
    }

    input {
      display: block;
      width: 100%;
      padding: 0 15px;
      background-color: $InputBackground;
      color: $InputColor;
      font-size: 1em;
      line-height: 50px;
      border: 0;
      outline: 0;
      @include border-radius(5px);
      
      @include respond(md-up) {
        line-height: 70px;
      }
    }

    .error {
      color: #a62e2e;
    }
    
    .success {
      color: #36ca1c;
    }

    .icon {
      position: absolute;
      top: 0;
      right: 20px;
      font-size: 24px;
      line-height: 50px;
      @include respond(md-up) {
        line-height: 70px;
      }
    }

    p {
      display: block;
      margin: 0;
      font-size: 12px;
      line-height: normal;
      text-align: right;
    }
  }
</style>